export default "__VITE_ASSET__CNjMIUpx__"